import { Box, IconButton, Typography } from "@mui/material";
import { MdEventSeat, MdQrCodeScanner } from "react-icons/md";

export const PassengerInfoCard = ({ passenger, onScanClick }) => {
  const { SeatNo, Gender, PaxName, PassengerContactNo1, BookingID, RouteShortName, PickupName } =
    passenger;

  return (
    <Box
      sx={{
        display: "flex",
        border: "1px solid #ddd",
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: passenger?.PaxStatus === "B" ? "#BFEEBF" : "#fff",
      }}
    >
      <Box
        sx={{
          width: 70,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          borderRight: "1px solid #ddd",
        }}
      >
        <IconButton
          size="small"
          onClick={(e) => e.stopPropagation()}
          color="primary"
          sx={{ padding: 0 }}
        >
          <MdEventSeat size={24} />
        </IconButton>

        <Typography fontWeight={600}>
          {SeatNo} ({Gender})
        </Typography>
      </Box>

      <Box sx={{ flex: 1, p: 1.5, position: "relative" }}>
        <Box display="flex" justifyContent="space-between">
          <Typography fontWeight={600}>{PaxName}</Typography>
          <Typography>{PassengerContactNo1}</Typography>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={0.5}>
          <Typography>{BookingID}</Typography>
          <Typography>{RouteShortName}</Typography>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" mt={0.5}>
          <Typography color="text.secondary">{PickupName}</Typography>
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              onScanClick?.(passenger);
            }}
            sx={{ padding: 0 }}
          >
            <MdQrCodeScanner size={22} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
